@if(dialogDataService.dialogData()?.overlappingMeetings; as meetings){
<schedule-viewer-part [meetings]="meetings"></schedule-viewer-part>

} @else {
<common-message alertType='info'>
	No Schedule Information Available
</common-message>
}